$(document).on('click', 'a[data-copy-to-clipboard]', function(e) {
  var el, text;
  e.preventDefault();
  text = e.target.getAttribute('data-copy-to-clipboard');
  el = $("<input type='text' value='" + text + "'/>");
  $('body').append(el);
  el.select();
  document.execCommand("copy");
  return el.remove();
});
